"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdgeKeyOne = void 0;
/**
 * This entity represents the output of an edge delete impulse
 */
var EdgeKeyOne = /** @class */ (function (_super) {
    __extends(EdgeKeyOne, _super);
    function EdgeKeyOne() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "EdgeKeyOne";
        _this.source = function () {
            _this.push(function (_) { return "source"; });
        };
        _this.edgeId = function () {
            _this.push(function (_) { return "edgeId"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return EdgeKeyOne;
}(Array));
exports.EdgeKeyOne = EdgeKeyOne;
//# sourceMappingURL=EdgeKeyOne.js.map